import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // We can safely use AuthService here since guards are not part of the 
    // circular dependency chain with HTTP interceptors
    return this.authService.checkAuthStatus(true).pipe(
      take(1),
      map(status => {
        if (status.isAuthenticated) {
          return true;
        } else {
          // User not authenticated, redirect to login
          this.authService.redirectToLogin(state.url);
          return false;
        }
      })
    );
  }
}